import React from 'react';
import { Button } from '../UI/Button';
import { MessageSquare, Users, Briefcase, Award, Building2 } from 'lucide-react';
import { Link } from 'react-router-dom';
interface AccessPointsProps {
  openPaymentForm?: () => void;
  openCorporateTrainingForm?: () => void;
}
export const AccessPoints = ({
  openPaymentForm,
  openCorporateTrainingForm
}: AccessPointsProps) => {
  return <section className="py-16 bg-gray-50" data-id="element-255">
      <div className="container mx-auto px-4" data-id="element-256">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-257">
          <h2 className="text-3xl font-bold mb-4 text-gray-800" data-id="element-258">
            Access Points into The Networking Salon
          </h2>
          <p className="text-gray-600" data-id="element-259">
            Choose your pathway into our community based on your goals and
            commitment level.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-260">
          {/* The Waiting Room */}
          <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col h-full" data-id="element-261">
            <div className="flex items-center mb-4" data-id="element-262">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-263">
                <MessageSquare size={24} className="text-gray-700" data-id="element-264" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-265">
                The Waiting Room
              </h3>
            </div>
            <p className="text-gray-600 mb-4 flex-grow" data-id="element-266">
              <span className="font-bold" data-id="element-267">Free Access</span> — An open,
              welcoming space for curious minds and aspiring community members.
              Connect with others, share ideas, and build early-stage
              relationships.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6" data-id="element-268">
              <li data-id="element-269">Submit approved announcements</li>
              <li data-id="element-270">Connect with community members</li>
              <li data-id="element-271">Discover networking opportunities</li>
            </ul>
            <Link to="/waiting-room" className="mt-auto" data-id="element-272">
              <Button variant="outline" className="w-full" data-id="element-273">
                Join Waiting Room
              </Button>
            </Link>
          </div>
          {/* Event Pathway */}
          <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col h-full" data-id="element-274">
            <div className="flex items-center mb-4" data-id="element-275">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-276">
                <Users size={24} className="text-gray-700" data-id="element-277" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-278">Event Pathway</h3>
            </div>
            <p className="text-gray-600 mb-4 flex-grow" data-id="element-279">
              <span className="font-bold" data-id="element-280">Paid Access</span> — Attend a Physical
              Networking Salon and gain access to our professional community.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6" data-id="element-281">
              <li data-id="element-282">Includes ongoing networking via community channels</li>
              <li data-id="element-283">Access to Virtual Coffee Chats held every two months</li>
            </ul>
            <Link to="/events" className="mt-auto" data-id="element-284">
              <Button variant="outline" className="w-full" data-id="element-285">
                Attend In-Person Event
              </Button>
            </Link>
          </div>
          {/* Inner Circle */}
          <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col h-full" data-id="element-286">
            <div className="flex items-center mb-4" data-id="element-287">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-288">
                <Briefcase size={24} className="text-gray-700" data-id="element-289" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-290">
                Inner Circle Membership
              </h3>
            </div>
            <p className="text-gray-600 mb-4 flex-grow" data-id="element-291">
              <span className="font-bold" data-id="element-292">Our yearly subscription</span> — For
              those ready to go deeper.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6" data-id="element-293">
              <li data-id="element-294">Includes all Event Pathway benefits</li>
              <li data-id="element-295">Access to the AI Tools Catalogue and Resource Hub</li>
              <li data-id="element-296">Four Mastermind Sessions yearly</li>
              <li data-id="element-297">
                Discounted access to Physical Events, Services, and Products
              </li>
              <li data-id="element-298">Group coaching + ongoing peer mentoring sessions</li>
            </ul>
            <Link to="/inner-circle" className="mt-auto" data-id="element-299">
              <Button className="w-full" data-id="element-300">Join Inner Circle</Button>
            </Link>
          </div>
          {/* Corporate Training */}
          <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col h-full" data-id="element-301">
            <div className="flex items-center mb-4" data-id="element-302">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-303">
                <Building2 size={24} className="text-gray-700" data-id="element-304" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-305">
                Corporate Training
              </h3>
            </div>
            <p className="text-gray-600 mb-4 flex-grow" data-id="element-306">
              <span className="font-bold" data-id="element-307">For Organizations & Teams</span> —
              Transform your team with expert-led training programs.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6" data-id="element-308">
              <li data-id="element-309">Networking & Collaboration</li>
              <li data-id="element-310">Artificial Intelligence & Digital Tools</li>
              <li data-id="element-311">Leadership & Strategic Communication</li>
              <li data-id="element-312">₦50,000 per participant per day</li>
              <li data-id="element-313">Minimum 5 participants</li>
            </ul>
            <Button variant="outline" className="w-full mt-auto" onClick={openCorporateTrainingForm} data-id="element-314">
              Request Training
            </Button>
          </div>
          {/* Lifetime Partner Access */}
          <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col h-full md:col-span-2" data-id="element-315">
            <div className="flex items-center mb-4" data-id="element-316">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-317">
                <Award size={24} className="text-gray-700" data-id="element-318" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-319">
                Lifetime Partner Access
              </h3>
            </div>
            <p className="text-gray-600 mb-4 flex-grow" data-id="element-320">
              <span className="font-bold" data-id="element-321">For long-term collaborators</span> —
              And past event participants.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6" data-id="element-322">
              <li data-id="element-323">Includes all Inner Circle benefits</li>
              <li data-id="element-324">Exclusive Digital Transformation Roadmap</li>
              <li data-id="element-325">Access to the Book Library and Summaries Podcast</li>
              <li data-id="element-326">One-on-one engagement, ideation, and branding support</li>
            </ul>
            <Link to="/lifetime-partner" className="mt-auto" data-id="element-327">
              <Button className="w-full" data-id="element-328">Get Lifetime Partner Access</Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
};